import Page from '../../../../ui/Page'
import { Button, Col, Popconfirm, Row, Space, Table } from 'antd'
import useApplications from '../useApplications'
import { ColumnsType } from 'antd/lib/table'
import { ApplicationDtoResponse } from '../../../../interfaces/Applications/response/ApplicationDtoResponse'
import ApplicationStatusTag from '../ApplicationStatusTag'
import { useHistory } from 'react-router-dom'
import RowSpan from '../../../../ui/RowSpan'
import { DeleteOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { useState } from 'react'

const StudentApplicationPage = () => {
    const {
        data,
        methods: {
            handleRejectApplication
        }
    } = useApplications({ fetchAllApplications: true });
    const history = useHistory();

    const isApplicationDisciplineAndNotInProcess = (application: ApplicationDtoResponse) => {
        return application.typeId.id === 12 && application.statusId.id === 1;
    }

    const [openRejectApplicationPopConfir, setOpenRejectApplicationPopConfir] = useState(false);

    const showRejectApplicationPopconfirm = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.stopPropagation();
        setOpenRejectApplicationPopConfir(true);
    };

    const handleRejectApplicationPopconfirmOk = (id: number, e?: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e?.stopPropagation();
        setOpenRejectApplicationPopConfir(false);
        handleRejectApplication(id);
    }

    const handleRejectApplicationPopconfirmCancel = (e?: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e?.stopPropagation();
        setOpenRejectApplicationPopConfir(false);
    }

    const currentDay = new Date().getDay();

    // Check if today is Saturday (6) or Sunday (0)
    // const isWeekend = currentDay === 0 || currentDay === 6;
    const isWeekend = false;

    const columns: ColumnsType<ApplicationDtoResponse> = [
        {
            "title": "№",
            "dataIndex": "key",
            "key": "key",
            render(value, record, index) {
                return index + 1;
            },
        },
        {
            "title": "Application type",
            "dataIndex": "typeId",
            "key": "typeId",
            render(value, record, index) {
                return record.typeId.nameEn;
            },
        },
        {
            "title": "Current step",
            "dataIndex": "currentStep",
            "key": "currentStep",
        },
        {
            "title": "Status",
            "dataIndex": "statusId",
            "key": "statusId",
            "width": "15%",
            render(value, record, index) {
                return (
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                            <ApplicationStatusTag statusNameRu={record.statusId.nameRu} />
                        </Col>
                        {isApplicationDisciplineAndNotInProcess(record) && (
                            <Col span={12}>
                                <Space size="middle">
                                    <Popconfirm
                                        style={{ position: "absolute", zIndex: 2 }}
                                        title={'Are you sure to withdraw this application?'}
                                        open={openRejectApplicationPopConfir}
                                        onConfirm={(e) => handleRejectApplicationPopconfirmOk(record.id, e)}
                                        onCancel={handleRejectApplicationPopconfirmCancel}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button danger icon={<MinusCircleOutlined />} onClick={showRejectApplicationPopconfirm}>
                                            withdraw
                                        </Button>
                                    </Popconfirm>
                                </Space>
                                {/* <Button
                                    danger
                                    style={{ position: "absolute", zIndex: 2 }}
                                    icon={<MinusCircleOutlined />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRejectApplication(record.id);
                                    }}>
                                    Reject
                                </Button> */}
                            </Col>
                        )}
                    </Row>
                );
            }
        },
    ];

    return (
        <Page title='Applications' subtitle='Page for applications'>
            <Space direction='vertical' style={{ width: "100%" }}>
                <RowSpan right={isWeekend ? (
                    <span style={{ color: 'red' }}>Application submission is not available on weekends</span>
                ) : (
                    <Button icon={<PlusOutlined />} onClick={() => history.push('/application/create')}>
                        Create the application
                    </Button>)}
                />
                <Table
                    columns={columns}
                    dataSource={data.applications}
                    loading={data.isLoadingApplications}
                    scroll={{ x: 1000 }}
                    rowKey={(record) => record.id.toString()}
                    onRow={(record) => {
                        return {
                            onClick: () => {
                                history.push(`/application/${record.id}`);
                            },
                            style: { cursor: 'pointer' },
                        };
                    }}
                />
            </Space>
        </Page>
    )
}

export default StudentApplicationPage